var map = {
	"./de-CH/index.json": [
		2415,
		2
	],
	"./de-DE/index.json": [
		2416,
		3
	],
	"./en-CA/index.json": [
		2417,
		5
	],
	"./en-GB/index.json": [
		2418,
		6
	],
	"./en-US/index.json": [
		2419,
		7
	],
	"./es-ES/index.json": [
		2420,
		8
	],
	"./fr-CA/index.json": [
		2421,
		9
	],
	"./fr-CH/index.json": [
		2422,
		10
	],
	"./fr-FR/index.json": [
		2423,
		11
	],
	"./it-IT/index.json": [
		2424,
		12
	],
	"./nl-NL/index.json": [
		2425,
		4
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1465;
module.exports = webpackAsyncContext;